import { ExceptionIgnoreScope, ExceptionPackageScope } from '../../../../../shared/issuesV2';

export const TOOLTIP_MAP = {
  [ExceptionIgnoreScope.Organization]: 'The issues will be ignored by all projects and release groups, including new ones.',
  [ExceptionIgnoreScope.ProjectAndReleaseGroups]: 'The issues will also be ignored in release groups that use the selected projects.',
  [ExceptionIgnoreScope.Policy]: 'The issues will be ignored by all projects and release groups that share the policy that created them.',
  [ExceptionPackageScope.AllVersions]: 'The issues will be ignored for all versions of the package, including future versions.',
  [ExceptionPackageScope.SelectedVersion]: 'The issue will only be ignored for the currently selected version.',
};
